import { ROUTE_GROUPS } from '@atlassian/jira-common-constants/src/spa-routes';

const HELP_CENTER_SETTINGS_URL = '/jira/helpcenter/projects/:projectKey/settings';

export const helpCenterSettingsKbRoute = {
	group: ROUTE_GROUPS.HELP_CENTER_SETTINGS,
	name: `${ROUTE_GROUPS.HELP_CENTER_SETTINGS}-kb`,
	path: `${HELP_CENTER_SETTINGS_URL}/kb`,
	exact: true,
};

export const helpCenterSettingsFormsRoute = {
	group: ROUTE_GROUPS.HELP_CENTER_SETTINGS,
	name: `${ROUTE_GROUPS.HELP_CENTER_SETTINGS}-forms`,
	path: `${HELP_CENTER_SETTINGS_URL}/forms`,
	exact: true,
};

export const helpCenterSettingsCustomerNotificationsRoute = {
	group: ROUTE_GROUPS.HELP_CENTER_SETTINGS,
	name: `${ROUTE_GROUPS.HELP_CENTER_SETTINGS}-customer-notifications`,
	path: `${HELP_CENTER_SETTINGS_URL}/customer-notifications`,
	exact: true,
};

export const helpCenterSettingsEmailRoute = {
	group: ROUTE_GROUPS.HELP_CENTER_SETTINGS,
	name: `${ROUTE_GROUPS.HELP_CENTER_SETTINGS}-email`,
	path: `${HELP_CENTER_SETTINGS_URL}/email`,
	exact: true,
};
